import type React from 'react';
import { useMediaUtils } from './useMediaUtils';

export const useHtmlCsvHandler = () => {
  const { isFirstPlay, push } = useMediaUtils('zngly_media_csv');

  const onMouseEnter = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (!isFirstPlay.current) {
      isFirstPlay.current = true;
      push('play');
    }
  };

  return {
    onMouseEnter,
  };
};
